module.exports = __webpack_public_path__ + "img/4.0dd6df59.webp";